import { createApp } from 'vue';
import app from './app.vue';

createApp(app).mount('#app');
